var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesQAndAGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.9 58.74L133.09 136.59C132.978 137.879 132.359 139.07 131.369 139.903C130.379 140.735 129.099 141.141 127.81 141.03L58.4902 135C57.2006 134.886 56.009 134.264 55.1767 133.273C54.3444 132.281 53.9393 131 54.0502 129.71L61.9302 39.58C62.0472 38.2914 62.669 37.1014 63.66 36.2696C64.6511 35.4378 65.9309 35.0317 67.2202 35.14L125.02 40.14L139.9 58.74Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2299 26.04L71.5099 27.68L69.8799 8.95996L90.2299 26.04Z",
    fill: "#B4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2299 26.04L71.5099 27.68L69.8799 8.95996L90.2299 26.04Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2201 51.3499L31.1001 50.0599C30.5021 50.3512 29.8536 50.5244 29.1901 50.5699C26.1301 50.8399 24.0201 48.8499 23.7201 45.4199C23.4201 41.9899 25.1501 39.6499 28.2101 39.4199C31.2701 39.1899 33.3901 41.1399 33.6901 44.5699C33.828 45.441 33.7586 46.3322 33.4875 47.1714C33.2165 48.0106 32.7514 48.7741 32.1301 49.3999L33.7401 51.2499L32.2201 51.3499ZM30.2201 49.0499L28.7001 47.3099L30.2201 47.1799L31.2201 48.3599C31.6451 47.8546 31.9547 47.2626 32.1274 46.6253C32.3001 45.988 32.3317 45.3207 32.2201 44.6699C31.9901 41.9999 30.4601 40.4399 28.2201 40.6699C25.9801 40.8999 24.7701 42.6699 25.0001 45.3399C25.2301 48.0099 26.7701 49.5599 29.0001 49.3399C29.4202 49.3128 29.8327 49.2147 30.2201 49.0499Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2602 83.7199L29.9602 84.0899L29.1402 87.2899L27.7202 87.4099L30.7702 76.2399L32.1002 76.1199L37.0002 86.5999L35.5802 86.7199L34.2602 83.7199ZM30.2602 82.9099L33.7702 82.6099L31.6002 77.8199L30.2602 82.9099Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6299 26.25L88.1199 31.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0002 73.8399L80.1102 72.3699C79.4598 72.5502 78.7816 72.6078 78.1102 72.5399C75.0402 72.2699 73.3102 69.9499 73.6102 66.5399C73.9102 63.1299 76.0202 61.1199 79.0902 61.3799C82.1602 61.6399 83.8802 63.9799 83.5802 67.3799C83.5676 68.2609 83.3463 69.1263 82.9343 69.9051C82.5223 70.6839 81.9314 71.3538 81.2102 71.8599L82.4902 73.9999L81.0002 73.8399ZM79.4002 71.2199L78.2102 69.2199L79.7302 69.3499L80.5402 70.6899C81.0546 70.2719 81.4715 69.7466 81.7617 69.1507C82.0519 68.5548 82.2084 67.9026 82.2202 67.2399C82.4502 64.5699 81.2202 62.7699 79.0002 62.5799C76.7802 62.3899 75.2502 63.9399 75.0002 66.5799C74.7502 69.2199 76.0002 71.0499 78.2202 71.2399C78.6121 71.2966 79.0105 71.2899 79.4002 71.2199Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3598 106.06L73.0598 105.69L71.6998 108.69L70.2798 108.56L75.2198 98.0898L76.5498 98.2098L79.5498 109.38L78.1298 109.26L77.3598 106.06ZM73.5598 104.57L77.0698 104.88L75.7698 99.7898L73.5598 104.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.62 113.05L20.69 115.45C20.0503 115.506 19.4057 115.436 18.7933 115.242C18.1809 115.049 17.6127 114.737 17.1212 114.323C16.6298 113.91 16.2247 113.403 15.9294 112.833C15.634 112.263 15.4541 111.64 15.4 111L7.52 20.88C7.46388 20.238 7.5355 19.5911 7.73074 18.9769C7.92597 18.3627 8.24094 17.7932 8.65748 17.3013C9.07401 16.8095 9.58384 16.405 10.1575 16.1113C10.7312 15.8176 11.3575 15.6404 12 15.59L69.8 10.54",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8799 40.8599L55.4699 39.1699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6401 49.5801L54.0301 48.0801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 59.4698L53.0998 56.8398",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.04 76.9601L52.49 76.0801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 85.67L51.0098 84.99",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.96 95.57L49.65 93.79",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 58.9799L123.78 57.3399L125.42 38.6199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3501 64.6599L124.21 67.7099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5898 73.3799L123.45 76.4199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2402 80.72L116.57 84.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1899 100.76L121.05 103.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4302 109.47L120.29 112.52",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0898 116.81L113.41 120.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesQAndAGrey);
export default __webpack_public_path__ + "static/media/pages_q_and_a_grey.09941ed897d212b7854c63b326ec6329.svg";
export { ForwardRef as ReactComponent };